import React from "react";
import { ArrowRight } from "lucide-react";
import { REGISTRATION_URL, LOGIN_URL, SITE } from "@/lib/config";
import RegistrationForm from "@/components/members/RegistrationForm";
import SEO, { breadcrumbSchema } from "@/components/seo/SEO";

export default function MembersArea() {
    return (
        <div data-testid="members-area-page" className="bg-white">
            <SEO
                title="Hazte socio · Área de socios"
                description="Únete a ASATTA por 15 €/mes y forma parte de la asociación que representa a los alojamientos turísticos de Tarifa. Regístrate en un minuto."
                path="/area-socios"
                jsonLd={breadcrumbSchema([
                    { name: "Inicio", path: "/" },
                    { name: "Área de socios", path: "/area-socios" },
                ])}
            />
            <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-24 pb-24">
                <div className="text-xs uppercase tracking-widest text-[#082050]/70 mb-4">
                    Área de socios
                </div>
                <h1 className="text-4xl sm:text-5xl font-semibold text-[#082050] tracking-tight">
                    Accede a tu área privada.
                </h1>
                <p className="mt-4 text-lg text-[#4A5568]">
                    Los servicios y herramientas para socios de ASATTA se gestionan desde
                    nuestra app. Accede con tus credenciales o regístrate por{" "}
                    <span className="text-[#082050] font-medium">{SITE.quota}</span>.
                </p>
                <p className="mt-3 text-sm text-[#4A5568] max-w-2xl">
                    {SITE.commitment}
                </p>

                <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6 items-stretch">
                    <div className="border border-[#E2E4E9] p-8 flex flex-col h-full">
                        <div className="text-xs uppercase tracking-widest text-[#082050]/60">Ya soy socio</div>
                        <h3 className="mt-2 text-xl font-semibold text-[#082050] tracking-tight">
                            Accede a tu portal
                        </h3>
                        <p className="mt-3 text-sm text-[#4A5568] leading-relaxed">
                            Entra con tu email y contraseña para gestionar tu ficha, ver
                            comunicaciones y acceder a los servicios exclusivos para
                            asociados de ASATTA.
                        </p>
                        <a
                            href={LOGIN_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="btn-login-app"
                            className="mt-auto pt-6 self-start inline-flex items-center gap-2 border border-[#082050] text-[#082050] px-6 py-3 text-sm font-medium hover:bg-[#082050]/5"
                        >
                            Eres socio, accede a tu portal
                            <ArrowRight size={14} />
                        </a>
                    </div>
                    <div className="border border-[#E2E4E9] p-8 bg-[#082050] text-white flex flex-col h-full">
                        <div className="text-xs uppercase tracking-widest text-white/60">Aún no soy socio</div>
                        <h3 className="mt-2 text-xl font-semibold tracking-tight text-white">
                            Únete a ASATTA
                        </h3>
                        <p className="mt-3 text-sm text-white/80 leading-relaxed">
                            Regístrate en la app para completar el alta como socio de
                            ASATTA por {SITE.quota} y forma parte de la asociación que
                            representa al alojamiento turístico de Tarifa.
                        </p>
                        <a
                            href="https://app.asatta.org/alta-socio"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="btn-hazte-socio-members"
                            className="mt-auto pt-6 self-start inline-flex items-center gap-2 bg-white text-[#082050] px-6 py-3 text-sm font-medium hover:bg-white/90"
                        >
                            Hazte socio
                            <ArrowRight size={14} />
                        </a>
                    </div>
                </div>

                <RegistrationForm />
            </section>
        </div>
    );
}
